function loadRuntimeModules(runtime) {
  runtime.loadModule(
    require('/Users/tracy/Desktop/Ezcon/ezproui/node_modules/build-plugin-app-core/lib/runtime.js')
  );

  runtime.loadModule(
    require('/Users/tracy/Desktop/Ezcon/ezproui/node_modules/build-plugin-ice-router/lib/runtime.js')
  );

  runtime.loadModule(
    require('/Users/tracy/Desktop/Ezcon/ezproui/node_modules/build-plugin-ice-logger/lib/runtime.js')
  );

  runtime.loadModule(
    require('/Users/tracy/Desktop/Ezcon/ezproui/node_modules/build-plugin-ice-auth/lib/runtime.js')
  );
}

export default loadRuntimeModules;
